import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Label, Button, Select, MenuItem, Utils } from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import { SET_MODAL } from 'constants';
import useIntl from 'useIntl';
import cn from 'classnames';
import mes from './intl';
import './Account.scss';

function Account() {
  const t = useIntl();
  const dispatch = useDispatch();
  const accounts = useSelector((state) => state.accounts);

  const handleOnChange = ({ value }) => {
    if (value === 'new') return;
    const accId = AppUtils.makeShortAccountId(value);
    const url = AppUtils.makeUrl(`/events/${accId}/list`);
    Utils.toStorage('workspaceId', accId);
    document.location.href = url;
  };

  const showModalCreate = () => {
    dispatch({
      type: SET_MODAL,
      payload: {
        name: 'CreateWorkspace',
      },
    });
  };

  const renderAccounts = ({ list, active }) => {
    const accList = list.map((acc) => (
      <MenuItem
        styleName={cn('account__select__item', { active: acc.id === active })}
        key={acc.id}
        value={acc.id}
        label={acc.name}
        size="small"
        leftIcon={acc.id === active ? 'check' : null}
      />
    ));
    accList.unshift(
      <MenuItem
        styleName="account__select__create"
        key="new"
        value="new"
        size="small"
      >
        <Button
          styleName="account__select__create__btn"
          type="default"
          size="small"
          fontWeight="normal"
          label={t(mes.createWorkspace)}
          onClick={showModalCreate}
        />
      </MenuItem>
    );
    return accList;
  };

  return (
    <div styleName="account__wrap">
      <div styleName="account">
        <Label
          styleName="account__label"
          value={t(mes.workspace)}
          fontSize="small"
          visibility="disabled"
        />
        <Select
          styleName="account__select"
          onChange={handleOnChange}
          value={accounts.active}
        >
          {renderAccounts(accounts)}
        </Select>
      </div>
    </div>
  );
}

export default Account;
